import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const AgentType = () => {
  return(
    <SettingsMetaData propertyName={"AgentType"} viewPropertyName={"Agent Type"} />
  )
};

export default AgentType;
